export const FILE_UPLOAD_FAILED =
  'Unable to upload the file at this moment. Please try again after few minutes.';
export const DOCUMENT_DETAILS_UPDATE_FAILED =
  'Unable to edit the file details at this moment. Please try again after few minutes.';
export const FILE_VIRUS_DETECTION_ERROR =
  'The file cannot be uploaded. Either a virus is detected or the file is password protected. Please rectify and upload.';
export const EMPTY_FILE_ERROR =
  'The file cannot be uploaded as the file is empty. Please rectify and upload.';
